import { Link, useNavigate } from "react-router-dom";
import { GLOBAL_IMAGES, HEADER } from "../../assets/asset";
import { useSelector } from "react-redux";

export default function Header() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  console.log("user in header :: ", user);

  function yearStringToNumber(yearStr) {
    if (!yearStr || !yearStr.startsWith("Year ")) {
      return null;
    }

    try {
      const yearNum = parseInt(yearStr.split(" ")[1]);
      return yearNum + 1;
    } catch (error) {
      return null;
    }
  }

  const handleNotebookClick = () => {
    const yearId = yearStringToNumber(user?.year);
    if (yearId) {
      navigate("/lessonDashboard", { state: { yearId } });
    } else {
      console.error("Invalid or missing year data");
    }
  };

  console.log("yearStringToNumber(user.year):", yearStringToNumber(user?.year));

  return (
    <header className="w-full flex justify-between px-20 pt-3">
      <div className="left flex items-center gap-14">
        <Link to={"/"}>
          <img src={GLOBAL_IMAGES.dingo} className="h-20 w-auto" alt="" />
        </Link>
        <img
          src={GLOBAL_IMAGES.LoginBackButton}
          className="h-12 w-auto cursor-pointer"
          alt=""
          onClick={() => navigate(-1)}
        />
      </div>

      <div className="flex items-center gap-14 ">
        {/* <img
          src={GLOBAL_IMAGES.notebook}
          className="h-16 w-auto cursor-pointer"
          alt=""
          onClick={handleNotebookClick}
        /> */}
        {/* <Link to={"/badges"} className="relative flex flex-col items-center">
          <img src={GLOBAL_IMAGES.medal} className="h-16 w-auto" alt="" />
          <div className="w-2 h-2 bg-blue-500 rounded-full mt-1"></div>
        </Link> */}
      </div>

      <div className="right flex items-center gap-14">
        <Link to={"/report"}>
          <img src={HEADER.ReportCard} className="h-16 w-auto" alt="" />
        </Link>
        <Link to={"/settings"}>
          <img src={user?.profilephotos} className="h-20 w-auto" alt="" />
        </Link>
      </div>
    </header>
  );
}
